import request from '@/utils/request'
export function show(Number, Page, Name, Type) {
  return request({
    url: '/api/strategy/show',
    method: 'get',
    params: {
      Number,
      Page,
      Name,
      Type
    }
  })
}
export function getStrategyList(params) {
  return request({
    url: '/api/strategy/show',
    method: 'get',
    params: params
  })
}

export function add(StrategyName, Detail, Type) {
  return request({
    url: '/api/strategy/add',
    method: 'post',
    data: {
      StrategyName,
      Detail,
      Type
    }
  })
}

export function icAdd(StrategyName, Detail) {
  return request({
    url: '/api/strategy/icadd',
    method: 'post',
    data: {
      StrategyName,
      Detail
    }
  })
}

export function del(id, Name) {
  return request({
    url: '/api/strategy/delete',
    method: 'post',
    data: {
      id,
      Name
    }
  })
}

export function edit(id, StrategyName, Detail) {
  return request({
    url: '/api/strategy/edit',
    method: 'post',
    data: {
      id,
      StrategyName,
      Detail
    }
  })
}

export function icEdit(id, StrategyName, Detail) {
  return request({
    url: '/api/strategy/icedit',
    method: 'post',
    data: {
      id,
      StrategyName,
      Detail
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/Strategy.js